import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var all = new Map([['1', {
  com: function com() {
    return import('./on-job-en.vue');
  },
  lang: 'en',
  name: 'staff_name_en',
  key: '1853'
}], ['2', {
  com: function com() {
    return import('./on-job-th.vue');
  },
  lang: 'th',
  name: 'staff_name_th',
  key: '1851'
}], ['3', {
  com: function com() {
    return import('./wage-en.vue');
  },
  lang: 'en',
  name: 'staff_name_en',
  key: '1857'
}], ['4', {
  com: function com() {
    return import('./wage-th.vue');
  },
  lang: 'th',
  name: 'staff_name_th',
  key: '1854'
}], ['5', {
  com: function com() {
    return import('./obtain-en.vue');
  },
  lang: 'en',
  name: 'staff_name_en',
  key: '1862'
}], ['6', {
  com: function com() {
    return import('./obtain-th.vue');
  },
  lang: 'th',
  name: 'staff_name_th',
  key: '1859'
}]]);
export default {
  th: new Map([['1', {
    com: function com() {
      return import('./on-job-th.vue');
    },
    lang: 'th',
    name: 'staff_name_th',
    key: '1851'
  }], ['2', {
    com: function com() {
      return import('./wage-th.vue');
    },
    lang: 'th',
    name: 'staff_name_th',
    key: '1854'
  }], ['3', {
    com: function com() {
      return import('./obtain-th.vue');
    },
    lang: 'th',
    name: 'staff_name_th',
    key: '1859'
  }]]),
  en: new Map([['1', {
    com: function com() {
      return import('./on-job-en.vue');
    },
    lang: 'en',
    name: 'staff_name_en',
    key: '1853'
  }], ['2', {
    com: function com() {
      return import('./wage-en.vue');
    },
    lang: 'en',
    name: 'staff_name_en',
    key: '1857'
  }], ['3', {
    com: function com() {
      return import('./obtain-en.vue');
    },
    lang: 'en',
    name: 'staff_name_en',
    key: '1862'
  }]])
};